import styled from '@emotion/styled'

import SectionBase, * as Section from '@segment/matcha/recipes/Section'

import LogoCarousel from '@segment/templates/LogoCarousel'
import { carouselLogos } from '@segment/templates/LogoCarousel/data'

const copy = {
  heading: `Enterprise companies choose Segment`,
}

const logos = [
  carouselLogos.FOX,
  carouselLogos.IBM,
  carouselLogos.VMWARE,
  carouselLogos.THE_SKIMM,
  carouselLogos.LEVIS,
  carouselLogos.GOOGLE,
  carouselLogos.BONOBOS,
]

const LogoCarouselComponent = () => {
  return (
    <StyledSectionBase variant="noCopy">
      <Section.Contents>
        <LogoCarousel heading={copy.heading} logos={logos} />
      </Section.Contents>
    </StyledSectionBase>
  )
}

const StyledSectionBase = styled(SectionBase)`
  ${Section.Wrapper} {
    padding-top: 40px;
    padding-bottom: 40px;

    ${({ theme }) => theme.breakpoints.up(`md`)} {
      padding-bottom: 60px;
    }
  }
`

export default LogoCarouselComponent
